export const METAL_NAMES = {
  MTX_PART: "Mtx part.",
  MTX_GAZ: "Mtx gaz.",
};
